/*
 * A campaign's own artwork, on its way into a CSS grammar.
 *
 * §5 rule 6 permits a background image URL as an inline style; it does not
 * permit a colour, and nothing here sets one — the fallback tint lives on the
 * plate in the theme. The URL is backend data, so it is accepted only as a path
 * or an http(s) URL and its delimiters are percent-encoded: a raw value
 * carrying `")` would otherwise close the url() and inject declarations.
 */
export function bannerOf(campaign) {
    const raw = campaign?.background_image;
    if (typeof raw !== 'string' || !raw) return null;
    if (!/^(https?:\/\/|\/)/.test(raw)) return null;
    return raw.replace(/["'()\\\s]/g, encodeURIComponent);
}

export function hasBanner(campaign) {
    return bannerOf(campaign) !== null;
}

export function bannerStyle(campaign) {
    const safe = bannerOf(campaign);
    return safe ? {backgroundImage: `url("${safe}")`} : {};
}
